import React, { useState } from 'react';
import { Modal, Alert } from 'react-bootstrap';
import { FaTrash } from 'react-icons/fa';

export default function ConfirmDeleteModal({
  show,
  onHide,
  onConfirm,
  title = 'Подтверждение удаления',
  message,
  itemName,
  confirmLabel = 'Удалить',
}) {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleConfirm = async () => {
    setError('');
    setLoading(true);
    try {
      await onConfirm();
      onHide();
    } catch (err) {
      setError(err.message || 'Не удалось удалить');
    } finally {
      setLoading(false);
    }
  };

  const handleHide = () => {
    if (!loading) {
      setError('');
      onHide();
    }
  };

  return (
    <Modal show={show} onHide={handleHide} centered>
      <Modal.Header closeButton={!loading} className="app-surface">
        <Modal.Title className="d-flex align-items-center gap-2">
          <FaTrash className="text-danger" />
          {title}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="app-surface">
        {error && <Alert variant="danger">{error}</Alert>}
        <p className="mb-2">{message || 'Это действие нельзя отменить.'}</p>
        {itemName && (
          <div className="app-surface-muted p-2 rounded small fw-semibold">{itemName}</div>
        )}
      </Modal.Body>
      <Modal.Footer className="app-surface">
        <button type="button" className="app-btn" onClick={handleHide} disabled={loading}>
          Отмена
        </button>
        <button type="button" className="app-btn app-btn-danger" onClick={handleConfirm} disabled={loading}>
          {loading ? 'Удаление...' : confirmLabel}
        </button>
      </Modal.Footer>
    </Modal>
  );
}
